import { RegistereControl, useAppInfo } from "@eavfw/apps";
import { useClientContext, useSWRFetch } from "@eavfw/manifest"
import { Table, TableBody, TableCell, TableCellLayout, TableHeader, TableHeaderCell, TableRow } from "@fluentui/react-components";
import {
    Dialog,
    DialogTrigger,
    DialogSurface,
    DialogTitle,
    DialogBody,
    DialogActions,
    DialogContent,
    Button,
    useRestoreFocusTarget
} from "@fluentui/react-components";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import { MonacoEditorControl, MonacoEditorControlProps } from '@eavfw/monaco-editor-control'
import Editor, { DiffEditor, useMonaco, loader, EditorProps, OnMount, OnChange } from "@monaco-editor/react";
import type { editor } from 'monaco-editor/esm/vs/editor/editor.api';
const columns = [
    { columnKey: "name", label: "Name" },
    { columnKey: "path", label: "Path" },

];

export type ShowDocumentControlProps = { documentid?: string, onSave: () => void }
export const ShowDocumentControl = ({ documentid, onSave }: ShowDocumentControlProps) => {

    const monaco = useMonaco();

    const editorRef = React.useRef<editor.IStandaloneCodeEditor>();

    const handleEditorDidMount: OnMount = (editor, monaco) => {
        editorRef.current = editor;
        editor.onDidContentSizeChange(() => {
            // setHeight(Math.max(100, editor.getContentHeight()));
            editor.layout();
        });
    };
    const [changedValue,setChangedValue] = useState<string>();
    const handleEditorOnChange: OnChange = useCallback((value) => {
        if (value) {
            console.log(value);
            setChangedValue(JSON.parse(value));
        }
    }, []);

    useEffect(() => {
        if (monaco) {
            console.log("here is the monaco isntance:", monaco);
            monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
                validate: true, allowComments: true,
                //schemas: schemas,
                schemaValidation: "error",
            });
        }
    }, [monaco]);

    const { data } = useSWRFetch(`/files/${documentid}`);
    const document = useMemo(() => JSON.stringify(data), [data]);
    const { baseUrl, onRequestInit } = useClientContext();
    const _onSave = useCallback(() => {

        fetch(`${baseUrl}/files/${documentid}`, {
            method: "PUT",
            body: JSON.stringify(changedValue),
            credentials: "include"
        }).then(() => {
            onSave();
        });
        
    }, [changedValue]);

    return (<>
        <DialogTitle>Dialog title</DialogTitle>
        <DialogContent >
            <div style={{ height: "100%", width: "100%" }} >
                <Editor
                    options={{
                        automaticLayout: true,
                        scrollBeyondLastLine: false
                    }}
                    onChange={handleEditorOnChange}
                    onMount={handleEditorDidMount}
                    defaultLanguage="json"
                    value={document}
                />
            </div>
        </DialogContent>
        <DialogActions>
            <DialogTrigger disableButtonEnhancement>
                <Button appearance="secondary">Close</Button>
            </DialogTrigger>

            <Button onClick={_onSave} appearance="primary">Do Something</Button>
        </DialogActions>
    </>)
}

import {
    FolderRegular,
    EditRegular,
    OpenRegular,
    DocumentRegular,
    PeopleRegular,
    DocumentPdfRegular,
    VideoRegular,
    DeleteRegular,
} from "@fluentui/react-icons";

export const DocumentsViewer = () => {

    const { currentRecordId } = useAppInfo()
    const { data } = useSWRFetch(`/entities/MigrationProjects/records/${currentRecordId}/documents/`);
    const items = data?.items as any[];

    //   const [open, setOpen] = React.useState(false);
    const [activedocument, setActiveDocument] = useState<string>();
    const restoreFocusTargetAttribute = useRestoreFocusTarget();

    if (!items)
        return null;
    return (
        <div>
            <Dialog open={typeof activedocument !== "undefined"} >

                <DialogSurface style={{ minWidth: "90vw" }} >
                    <DialogBody style={{ minHeight: "80vh", }} >
                        <ShowDocumentControl documentid={activedocument} onSave={() => setActiveDocument(undefined)} />
                    </DialogBody>
                </DialogSurface>
            </Dialog>
            <Table size="small" aria-label="Table with small size">
                <TableHeader>
                    <TableRow>
                        {columns.map((column) => (
                            <TableHeaderCell key={column.columnKey}>
                                {column.label}
                            </TableHeaderCell>
                        ))}
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {items.map((item) => (
                        <TableRow key={item.id}>
                            <TableCell>
                                <TableCellLayout>
                                    <Button {...restoreFocusTargetAttribute} onClick={() => setActiveDocument(item.id)} icon={<EditRegular />} aria-label="Edit" />
                                    <Button {...restoreFocusTargetAttribute} icon={<OpenRegular />} onClick={() => window.open(`/api/files/${item.id}`,'_blank')}  aria-label="Open" />

                                    
                                    {item.name}
                                </TableCellLayout>
                            </TableCell>
                            <TableCell>
                                <TableCellLayout>
                                    {item.path}
                                </TableCellLayout>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    )

    return <div><pre>{JSON.stringify(data)}</pre></div>
}

RegistereControl('DocumentsViewer', DocumentsViewer)